const data = [
  {
    id: '1',
    title: 'Nitrosales',
    description:
      'NitroSales optimise la force de vente en centralisant la gestion des stocks, des commandes et des livraisons, offrant une vue d\'ensemble à 360° pour une gestion efficace.',
    image: {
      src: 'https://res.cloudinary.com/deslpwcxk/image/upload/v1726787063/nitrosales_ggugz3.png',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://www.nitrosales.ma/',
    },
    technologies: [
      '#Java',
      '#Spring',
      '#Keycloak',
      '#Hibernate',
      '#RestFull',
      '#Swagger',
      '#Postgresql',
      '#Lombok',
      '#Minio',
      '#Jasperreports',
    ],
  },
  {
    id: '2',
    title: 'Syndibox',
    description:
      'SyndiBox simplifie la gestion des copropriétés avec une communication améliorée et une interface sécurisée, optimisant ainsi la gestion et le gain de temps.',
    image: {
      src: 'https://res.cloudinary.com/deslpwcxk/image/upload/v1726847426/syndibox_jo5qzu.png',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://www.syndibox.com/',
    },
    technologies: [
      '#Java',
      '#Spring',
      '#Keycloak',
      '#Hibernate',
      '#RestFull',
      '#Swagger',
      '#Postgresql',
      '#Lombok',
      '#Minio',
      '#Jasperreports',
    ],
  },
  {
    id: '3',
    title: 'Kapiscan',
    description:
      'KapiScan optimise la gestion des stocks en scannant les QR codes des produits pour afficher instantanément leur disponibilité et détails dans chaque magasin.',
    image: {
      src: 'https://res.cloudinary.com/deslpwcxk/image/upload/v1726847736/Kapiscan_yjvjtl.jpg',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://kapisoft.ma/solution-emb2',
    },
    technologies: [
      '#Windev Mobile',
      '#Spirng',
      '#MySQL',
    ],
  },
  {
    id: '4',
    title: 'MediManage',
    description:
      'MediManage simplifie la gestion des cabinets médicaux en centralisant la gestion des rendez-vous, dossiers médicaux digitalisés, employés, paiements et bien plus, optimisant ainsi l\'efficacité du cabinet.',
    image: {
      src: 'https://res.cloudinary.com/deslpwcxk/image/upload/v1726849090/MediManage_vt2tzx.jpg',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      repo: 'https://github.com/Nafia-elyaakoubi/MediManage',
    },
    technologies: [
      '#Java',
      '#Spring',
      '#Spring Security',
      '#Hibernate',
      '#RestFull',
      '#Postman',
      '#MySQL',
      '#TypeScript',
      '#Angular',
    ],
  },
  {
    id: '5',
    title: 'PharmaResources',
    description:
      'PharmaResources optimise la gestion des ressources informatiques chez Pharma5 en centralisant les applications, les ressources, et les procédures internes pour une gestion efficace et simplifiée',
    image: {
      src: 'https://res.cloudinary.com/deslpwcxk/image/upload/v1726850328/PharmaResources_dw2sw5.png',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      repo: 'https://www.pharma5.ma/',
    },
    technologies: [
      '#Java',
      '#Spring',
      '#Spring Security',
      '#Hibernate',
      '#RestFull',
      '#Postman',
      '#MySQL',
      '#TypeScript',
      '#React',
      '#Materialize css',
    ],
  },
];

export default data;
